"use client";

import { c as _c } from "react/compiler-runtime";
import { SortingEnum } from "@sprawdzonabron/shared";
import { useEffect, useRef, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { HiSortAscending } from "react-icons/hi";
import { TestIdEnum } from "../../../tests/types";
const items = [{
  label: "Domyślnie",
  value: SortingEnum.Default
}, {
  label: "Alfabetycznie",
  value: SortingEnum.Alphabetic
}, {
  label: "Cena: od najniższej",
  value: SortingEnum.PriceFromLowToHigh
}, {
  label: "Cena: od najwyższej",
  value: SortingEnum.PriceFromHighToLow
}];
interface SorterProps {
  value?: SortingEnum;
  onChange: (value: SortingEnum) => void;
}
export const Sorter = t0 => {
  const $ = _c(22);
  const {
    value: t1,
    onChange
  } = t0;
  const value = t1 === undefined ? SortingEnum.Default : t1;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  let t2;
  if ($[0] !== value) {
    t2 = items.find(item => item.value === value)?.label;
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedLabel = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleClickOutside = event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== isOpen) {
    t5 = () => setIsOpen(!isOpen);
    $[4] = isOpen;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HiSortAscending className="w-4 h-4 mr-2" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== selectedLabel) {
    t7 = <span className="text-ellipsis whitespace-nowrap overflow-hidden">{selectedLabel}</span>;
    $[7] = selectedLabel;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `w-4 h-4 ml-2 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`;
  let t9;
  if ($[9] !== t8) {
    t9 = <FiChevronDown className={t8} />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t7 || $[13] !== t9) {
    t10 = <button type="button" onClick={t5} aria-label="Sortowanie" data-testid={TestIdEnum.SorterButton} className="inline-flex justify-between items-center w-40 md:w-48 px-1.5 py-1.5 text-xs md:text-sm font-medium text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-lg shadow-sm hover:bg-slate-50 dark:hover:bg-slate-750 focus:outline-none focus:ring-2 focus:ring-brand-500">{t6}{t7}{t9}</button>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isOpen || $[16] !== onChange || $[17] !== value) {
    t11 = isOpen && <div className="absolute right-0 z-10 w-48 mt-2 origin-top-right bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 animate-fade-in"><div className="py-1">{items.map(item_0 => <button key={item_0.value} onClick={() => {
          onChange(item_0.value);
          setIsOpen(false);
        }} data-testid={`${TestIdEnum.SorterOption}-${item_0.value}`} className={`block w-full px-4 py-2 text-xs md:text-sm text-left transition-colors ${value === item_0.value ? "bg-brand-50 dark:bg-brand-900/30 text-brand-700 dark:text-brand-400 font-semibold" : "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700"}`}>{item_0.label}</button>)}</div></div>;
    $[15] = isOpen;
    $[16] = onChange;
    $[17] = value;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div className="relative inline-block text-left" ref={dropdownRef}>{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};